import React, {useEffect, useState} from 'react';
import * as Icon from 'ubs-icons';
import {useSelector} from "react-redux";
import {getCookie, createCookie} from 'ubs-framework/v2/common/function';
import {sendData} from "../../../store/actions";
import {CONSTANT} from "../../../common/constant";
import {messaging} from "./init-fcm";
import {getToken, onMessage} from "firebase/messaging";
import {useHistory} from "react-router-dom";
import {FCM_CONFIG} from "../../../common/constant";

const PushNotification = React.memo(() => {
    const history = useHistory();

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _TAB_ID = useSelector(e => e.common.tabId);

    const [allow, setAllow] = useState(localStorage.getItem('allow_notification'));
    const [moreOptions, setMoreOptions] = useState(false)
    /** more options */

    const openMoreOptions = () => {
        setMoreOptions(!moreOptions)
    }

    const allowNotification = () => {
        if (Object.keys(messaging).length && FCM_CONFIG) {
            Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    getToken(messaging, {vapidKey: window.location.hostname.includes('superworks.com')?
                            "BJj-25BJIfzKiSDH8wYmuE4LhDQTGhzVxsk_6HBfqejhl0h86tzE5XsqqmO9MdGYDJfN4o_RMLVYtTbSYEZ_Slc":
                            "BDTq76p6ZUPBycdblk8wHcdMGUDnKp4Lkqyv2JEmSsvfM6KQSqV6xEiKwqMr6Eq7Pe2AuGat4eJy3ClY7_0-0bg"})
                        .then((token) => {
                            if (token) {
                                setAllow('');
                                createCookie('fcm_recruit', token)
                                sendData('updateDeviceToken', {device_token: token, platform: CONSTANT.PLATFORM});
                            } else {
                                // Show permission request UI
                                console.log('No registration token available. Request permission to generate one.');
                                permission.handle();
                            }
                        })
                        .catch((err) => {
                            console.log('An error occurred while retrieving token. ', err);
                        });
                }
            });

        }
    };

    const permission = {
        handle: () => {
            return navigator.permissions.query({name: 'notifications'}).then(permission.query).catch(permission.error);
        },
        error: () => {
            if (allow !== 'never') setAllow('cancel');
        },
        query: result => {
            if (allow !== 'never') {
                if (result.state === 'denied') setAllow('block');
                else setAllow('cancel');
            }
        },
    }
    const changeNotificationType = e => {
        if (e === '') allowNotification();
        else setAllow(e);
    };

    useEffect(() => {
        const a = localStorage.getItem('allow_notification');
        if (a && a !== allow) setAllow(a);

        if (CONSTANT.PLATFORM === 'web') allowNotification();
        if (navigator.serviceWorker) {
            onMessage(messaging, (payload) => {
                console.log("FG===================>>", payload)
                if (_ORG_ID.length !== 0 && _TAB_ID === getCookie(_ORG_ID) && !document.hasFocus()) {
                    const options = {
                        body: payload.data.body,
                        icon: payload.data.icon,
                        data: payload.data.click_action, //the url which we gonna use later
                        sound: '/sound.mp3',
                        silent: true,
                    };
                    const a = new Audio('/sound.mp3');
                    a.play();
                    const notification = new Notification(payload.data.title, options);
                    notification.onclick = (event) => {
                        const parsedClient = new URL(event.target.data);
                        const parsedUrl = new URL(window.location.href);

                        const pathClient = parsedClient.pathname.split('/')
                        const pathUrl = parsedUrl.pathname.split('/')
                        if (pathClient[1] === pathUrl[1]) {
                            window.focus();
                            history.push(parsedClient.pathname)
                        }

                    };
                }
            });
            navigator.serviceWorker.addEventListener('message', (payload) => {
                console.log("BG===================>>>>>>", payload)
                if (payload.data && payload.data.type === 'BG') {
                    /**
                     * This is Background event handler
                     * */
                    const parsed = new URL(payload.data.url);
                    history.push(parsed.pathname)
                }
            });
        }
    }, []);

    useEffect(() => localStorage.setItem('allow_notification', allow), [allow]);

    return (
        <React.Fragment>
            {CONSTANT.PLATFORM === 'web' && allow === 'cancel' && <div>
                <div className='u_top-bar'>
                    <div className="u_top-bar-overlay" onClick={() => setMoreOptions(false)}/>
                    <div className="u_flex u_content-center u_item-center">
                        <p>
                            <span className="u_ib u_align-middle"><Icon.Notifications fill="#FFFFFF" size={16}
                                                                                      className="u_ib u_align-middle u_mr-5"/>Don't miss out! Super Recruit would like to send you notifications.
                                <button onClick={() => changeNotificationType('')} className="u_allow-button">Allow Notification</button>
                            </span>
                        </p>
                        <span className="u_notification-close-icon u_blue-bgicon" onClick={openMoreOptions}><Icon.Close
                            fill="#FFFFFF" size={14}/></span>
                    </div>
                    {moreOptions &&
                    <div className='u_notification-popover'>
                        <p>We highly recommend enabling notifications so you don’t miss out on any updates from your
                            team.</p>
                        <ul>
                            <li className="u_rollover-text u_cp" onClick={() => changeNotificationType('')}>Allow
                                Notifications
                            </li>
                            <li className="u_rollover-text u_cp" onClick={() => changeNotificationType('later')}>Remind
                                me later
                            </li>
                            <li className="u_rollover-text u_cp" onClick={() => changeNotificationType('never')}>Never
                                ask me again
                            </li>
                        </ul>
                    </div>
                    }
                </div>
            </div>}
        </React.Fragment>
    )
})

export default PushNotification

